import { Col } from 'antd'
import React, { useContext } from 'react'
import { FormItem } from '../../../../../../components/UIComponents/FormStyles'
import { RuleContext } from '../../RulesCreationTable'
import { StyledRuleRow, StyledTextInput } from '../../style'
import { StyledBoldTextOne, TextContainer, TextLine } from '../CTCDrawers/style'

const AbsenteeStudentsDrawer = () => {
  const {
    ruleForm,
    setState,
    state: { absentCount },
  } = useContext(RuleContext)

  const handleInputChange = e => {
    const currentAbsent = ruleForm.getFieldValue('absentCount')
    ruleForm.setFieldsValue({
      absentCount: {
        ...currentAbsent,
        missedEvaluationCount: e.target.value,
        // isEnabled: e.target.value ? true : false,
      },
    })
    setState(prevState => ({
      ...prevState,
      absentCount: {
        ...prevState.absentCount,
        missedEvaluationCount: e.target.value,
        // isEnabled: e.target.value ? true : false,
      },
    }))
  }
  return (
    <>
      <TextContainer>
        <TextLine>
          This rule restricts students from applying for roles if they skip or
          miss attending a specified number of evaluation rounds.
        </TextLine>
      </TextContainer>
      <StyledRuleRow align={'middle'} pBottom={20} pTop={30}>
        <Col md={8}>
          <StyledBoldTextOne>Missed rounds</StyledBoldTextOne>
        </Col>
        <Col>
          <FormItem
            name={['absentCount', 'missedEvaluationCount']}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value == 0) {
                    return Promise.reject(
                      new Error(
                        'Please enter the no. of missed evaluation rounds'
                      )
                    )
                  }
                  
                  if (value < 0) {
                    return Promise.reject(new Error('Negative values are not allowed'))
                  }
                  
                  return Promise.resolve()
                },
              }),
            ]}
          >
            <StyledTextInput
              type="number"
              placeholder="0"
              width="200px"
              height={'40px'}
              onChange={e => handleInputChange(e)}
              value={absentCount?.missedEvaluationCount || 0}
            />
          </FormItem>
        </Col>
      </StyledRuleRow>

      <TextContainer>
        <TextLine>
          If restricted due to missed (x no. of) evaluation rounds, the student
          may request <br /> Placement Officer approval to resume applying for
          roles.
        </TextLine>
      </TextContainer>
    </>
  )
}

export default AbsenteeStudentsDrawer
